import React, { useCallback, useContext, useState } from 'react';

import { reloadCompany } from 'common/actions/company';
import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import connect from 'common/core/connect';
import AdminJoinBetaModal from 'common/subdomain/admin/v2/modals/AdminJoinBetaModal';
import NoticeBar from 'common/uiV3/Composite/NoticeBar';

type ConnectProps = {
  reloadCompany: () => Promise<void>;
};

type OwnProps = Record<string, never>;

type Props = ConnectProps & OwnProps;

const AdminV2BetaNotice = ({ reloadCompany }: Props) => {
  const company = useContext(CompanyContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  const handleDismiss = useCallback(async () => {
    setIsDismissed(true);
    await AJAX.post('/api/nux/dismissNUX', {
      nuxType: 'adminIdeaBetaNotice',
    });
    reloadCompany();
  }, [reloadCompany]);

  if (company?.nux?.adminIdeaBetaNotice || isDismissed) {
    return null;
  }

  return (
    <>
      <NoticeBar
        message="Your team is eligible for the Ideas beta!"
        action={{
          type: 'button',
          label: 'Learn more',
          onClick: () => setIsModalOpen(true),
        }}
        dismissible
        onDismiss={handleDismiss}
      />
      <AdminJoinBetaModal isOpen={isModalOpen} onOpenChange={setIsModalOpen} />
    </>
  );
};

export default connect(null, { reloadCompany })(AdminV2BetaNotice) as unknown as React.FC<OwnProps>;
